import { combineReducers } from '@reduxjs/toolkit';

import app from './app';

export default combineReducers({
  app,
});
